import { Link } from 'react-router-dom';
import { useLogout } from '../../../Account/hooks/useLogout';
import { ACCOUNT_LINKS } from '../../../config';
import { DropdownMenu, DropdownItem } from 'reactstrap';

export const UserMenu: React.FC = () => {
	const logout = useLogout();

	return (
		<DropdownMenu style={{ width: '100%', marginTop: '-1px' }}>
			{ACCOUNT_LINKS.map(el => (
				<DropdownItem tag={Link} to={el.link} key={el.name}>
					{el.name}
				</DropdownItem>
			))}
			<DropdownItem
				onClick={() => logout()}
				className="text-primary hover-underline"
			>
				Logout
			</DropdownItem>
		</DropdownMenu>
	);
};
